import axios from 'axios';

import {
  TAB_CHILDREN,
  TAB_DEPENDENT,
  TAB_ENTITLEMENT,
  TAB_HISTORY,
  TAB_PRIVILEGE,
  TAB_SOD,
  TAB_SUMMARY,
} from '../../../components/CertsDetails/CertsSidePanel/constant';
import { httpService } from '../../../http-service/httpService';
import { setCommonError } from '../global/action';
import {
  axiosTimeoutConfig,
  CERT_DETAILS_SIDE_PANEL_VISIBLE,
  DATA_FETCH_ERROR,
  FORCED_CANCELLATION,
  FORCED_CANCELLATION_MESSAGE,
  SET_SIDE_PANEL_BODY_LOADING,
  SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS,
  SET_SIDE_PANEL_CHILDREN_ROLES,
  SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS,
  SET_SIDE_PANEL_ENTITLEMENT_ROLES,
  SET_SIDE_PANEL_ERROR,
  SET_SIDE_PANEL_HISTORY2_ACCOUNTS,
  SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS,
  SET_SIDE_PANEL_HISTORY2_ROLES,
  SET_SIDE_PANEL_HISTORY2_USERS,
  SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS,
  SET_SIDE_PANEL_SOD_ENTITLEMENTS,
  SET_SIDE_PANEL_SUMMARY_ACCOUNTS,
  SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS,
  SET_SIDE_PANEL_SUMMARY_ROLES,
  SET_SIDE_PANEL_SUMMARY_USERS,
  SIDE_PANEL_INITIAL_LOAD,
  SIDE_PANEL_LOAD_MORE_BUTTON,
} from '../types';
import {
  URL_ACCOUNT_SUMMARY_API,
  URL_AUDIT_HISTORY_API,
  URL_ENTITLEMENT_CHILD_API,
  URL_ENTITLEMENT_MAPPED_API,
  URL_ENTITLEMENT_PRIVILEDGES_API,
  URL_ENTITLEMENT_SOD_API,
  URL_ENTITLEMENT_SUMMARY_API,
  URL_ROLE_CHILD_API,
  URL_ROLE_ENTITLEMENTS_API,
  URL_ROLE_SUMMARY_API,
  URL_USER_SUMARY_API,
} from '../urls';

let cancelTokenForSidePanelBodySummaryForUsers;
let cancelTokenForSidePanelBodyHistoryForUsers;
let cancelTokenForSidePanelBodySummaryForRoles;
let cancelTokenForSidePanelBodyHistoryForRoles;
let cancelTokenForSidePanelBodyChildForRoles;
let cancelTokenForSidePanelBodyEntitlementForRoles;
let cancelTokenForSidePanelBodySummaryForAccounts;
let cancelTokenForSidePanelBodyHistoryForAccounts;
let cancelTokenForSidePanelBodySummaryForEntitlements;
let cancelTokenForSidePanelBodyHistoryForEntitlements;
let cancelTokenForSidePanelBodySodForEntitlements;
let cancelTokenForSidePanelBodyPrivilegesForEntitlements;
let cancelTokenForSidePanelBodyChildForEntitlements;
let cancelTokenForSidePanelBodyDependentForEntitlements;

export const setSidePanelVisible = (isVisible) => (dispatch) => {
  dispatch({
    type: CERT_DETAILS_SIDE_PANEL_VISIBLE,
    payload: isVisible,
  });
};

export const setSidePanelLoading = (status) => (dispatch) => {
  dispatch({
    type: SET_SIDE_PANEL_BODY_LOADING,
    payload: status,
  });
};

const clearSidePanelError = () => (dispatch) => {
  dispatch({
    type: SET_SIDE_PANEL_ERROR,
    payload: false,
  });
  dispatch(setCommonError({ isError: false, error: null }));
};

const setSidePanelErrorTryBlock = (error) => (dispatch) => {
  dispatch({
    type: SET_SIDE_PANEL_ERROR,
    payload: true,
  });
  dispatch(
    setCommonError({
      isError: false,
      error,
    })
  );
};

const setSidePanelErrorCatchBlock = (error) => (dispatch) => {
  dispatch({
    type: SET_SIDE_PANEL_ERROR,
    payload: error?.code !== FORCED_CANCELLATION,
  });
  dispatch(
    setCommonError({
      isError: false,
      error:
        error?.code === FORCED_CANCELLATION
          ? FORCED_CANCELLATION_MESSAGE
          : DATA_FETCH_ERROR,
    })
  );
};

export const getSidePanelSummaryForEntitlements =
  (eid, certkey, entValueKey, certEntVal2Key) => async (dispatch) => {
    const body = {
      eid,
      certkey,
      cert_entitlement_valuekey: entValueKey,
      certEntVal2Key,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodySummaryForEntitlements !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodySummaryForEntitlements.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodySummaryForEntitlements =
        axios.CancelToken.source();

      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodySummaryForEntitlements.token;

      const { data } = await httpService.post(
        URL_ENTITLEMENT_SUMMARY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS,
        payload: response,
      });

      return TAB_SUMMARY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelAuditHistoryForEntitlements =
  (certkey, entValueKey, userKey, accKey, roleKey, certEntVal2Key) =>
  async (dispatch) => {
    const body = {
      certkey,
      cert_entitlement_valuekey: entValueKey,
      cert_userkey: userKey,
      cert_accountkey: accKey,
      cert_rolekey: roleKey,
      certEntVal2Key,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyHistoryForEntitlements !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodyHistoryForEntitlements.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyHistoryForEntitlements =
        axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyHistoryForEntitlements.token;

      const { data } = await httpService.post(
        URL_AUDIT_HISTORY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS,
        payload:
          typeof response === 'object' && Array.isArray(response)
            ? response?.map((item, index) => ({
                ...item,
                index,
              }))
            : null,
      });

      if (typeof response === 'string')
        dispatch(setSidePanelErrorTryBlock(response));

      return TAB_HISTORY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelPrivilegesForEntitlements =
  (
    entValueKey,
    accKey,
    offset,
    max,
    loadMoreStatus = SIDE_PANEL_INITIAL_LOAD
  ) =>
  async (dispatch, getState) => {
    const {
      global: { certKey },
    } = getState().certifications.details;
    const body = {
      cert_entitlement_valuekey: entValueKey,
      cert_accountkey: accKey,
      offset: String(Number(offset) + 1),
      max,
      certkey: certKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyPrivilegesForEntitlements !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodyPrivilegesForEntitlements.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyPrivilegesForEntitlements =
        axios.CancelToken.source();

      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyPrivilegesForEntitlements.token;
      const { data } = await httpService.post(
        URL_ENTITLEMENT_PRIVILEDGES_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      if (loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        dispatch({
          type: SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS,
          loadMoreStatus,
          payload: {
            ...response,
            privileges: response?.privileges.map((item, index) => ({
              ...item,
              index: `${offset}-${index}`,
            })),
          },
        });
      }

      if (loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        dispatch({
          type: SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS,
          loadMoreStatus,
          payload: response?.privileges.map((item, index) => ({
            ...item,
            index: `${offset}-${index}`,
          })),
        });
      }

      return TAB_PRIVILEGE;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelSodForEntitlements =
  (
    certkey,
    entValueKey,
    accKey,
    offset,
    max,
    searchKey = '',
    loadMoreStatus = SIDE_PANEL_INITIAL_LOAD
  ) =>
  async (dispatch) => {
    const body = {
      certkey,
      cert_entitlement_valuekey: entValueKey,
      cert_accountkey: accKey,
      offset: String(Number(offset) + 1),
      max,
      searchKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodySodForEntitlements !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodySodForEntitlements.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodySodForEntitlements =
        axios.CancelToken.source();

      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodySodForEntitlements.token;
      const { data } = await httpService.post(
        URL_ENTITLEMENT_SOD_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      if (loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        dispatch({
          type: SET_SIDE_PANEL_SOD_ENTITLEMENTS,
          loadMoreStatus,
          payload: {
            ...response,
            risks: response?.risks.map((item, index) => ({
              ...item,
              index: `${offset}-${index}`,
            })),
          },
        });
      }

      if (loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        dispatch({
          type: SET_SIDE_PANEL_SOD_ENTITLEMENTS,
          loadMoreStatus,
          payload: response?.risks.map((item, index) => ({
            ...item,
            index: `${offset}-${index}`,
          })),
        });
      }

      return TAB_SOD;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_SOD_ENTITLEMENTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelChildForEntitlements =
  (entValueKey, offset, max, loadMoreStatus = SIDE_PANEL_INITIAL_LOAD) =>
  async (dispatch, getState) => {
    const {
      global: { certKey },
    } = getState().certifications.details;
    const body = {
      cert_entitlement_valuekey: entValueKey,
      offset: String(Number(offset) + 1),
      max,
      certkey: certKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyChildForEntitlements !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodyChildForEntitlements.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyChildForEntitlements =
        axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyChildForEntitlements.token;
      const { data } = await httpService.post(
        URL_ENTITLEMENT_CHILD_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      if (loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        dispatch({
          type: SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS,
          loadMoreStatus,
          payload: {
            ...response,
            childEntList: response?.childEntList.map((item, index) => ({
              ...item,
              index: `${offset}-${index}`,
            })),
          },
        });
      }

      if (loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        dispatch({
          type: SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS,
          loadMoreStatus,
          payload: response?.childEntList.map((item, index) => ({
            ...item,
            index: `${offset}-${index}`,
          })),
        });
      }

      return TAB_CHILDREN;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelDependentsForEntitlements =
  (entValueKey, offset, max, loadMoreStatus = SIDE_PANEL_INITIAL_LOAD) =>
  async (dispatch, getState) => {
    const {
      global: { certKey },
    } = getState().certifications.details;
    const body = {
      cert_entitlement_valuekey: entValueKey,
      offset: String(Number(offset) + 1),
      max,
      certkey: certKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyDependentForEntitlements !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodyDependentForEntitlements.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyDependentForEntitlements =
        axios.CancelToken.source();

      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyDependentForEntitlements.token;
      const { data } = await httpService.post(
        URL_ENTITLEMENT_MAPPED_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      if (loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        dispatch({
          type: SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS,
          loadMoreStatus,
          payload: {
            ...response,
            mappedEntList: response?.mappedEntList.map((item, index) => ({
              ...item,
              index: `${offset}-${index}`,
            })),
          },
        });
      }

      if (loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        dispatch({
          type: SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS,
          loadMoreStatus,
          payload: response?.mappedEntList.map((item, index) => ({
            ...item,
            index: `${offset}-${index}`,
          })),
        });
      }

      return TAB_DEPENDENT;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelSummaryForAccounts =
  (eid, certKey) => async (dispatch) => {
    const body = {
      eid,
      certkey: certKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodySummaryForAccounts !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodySummaryForAccounts.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodySummaryForAccounts =
        axios.CancelToken.source();

      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodySummaryForAccounts.token;
      const { data } = await httpService.post(
        URL_ACCOUNT_SUMMARY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_SUMMARY_ACCOUNTS,
        payload: response,
      });

      return TAB_SUMMARY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_SUMMARY_ACCOUNTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelAuditHistoryForAccounts =
  (certkey, entValueKey, userKey, accKey) => async (dispatch) => {
    const body = {
      certkey,
      cert_entitlement_valuekey: entValueKey,
      cert_userkey: userKey,
      cert_accountkey: accKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyHistoryForAccounts !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodyHistoryForAccounts.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyHistoryForAccounts =
        axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyHistoryForAccounts.token;
      const { data } = await httpService.post(
        URL_AUDIT_HISTORY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_HISTORY2_ACCOUNTS,
        payload:
          typeof response === 'object' && Array.isArray(response)
            ? response?.map((item, index) => ({
                ...item,
                index,
              }))
            : null,
      });

      if (typeof response === 'string')
        dispatch(setSidePanelErrorTryBlock(response));

      return TAB_HISTORY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_HISTORY2_ACCOUNTS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelSummaryForUsers =
  (eid, certkey, userKey) => async (dispatch) => {
    const body = {
      eid: eid || '',
      certkey,
      cert_userkey: userKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodySummaryForUsers !== typeof undefined
      ) {
        cancelTokenForSidePanelBodySummaryForUsers.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodySummaryForUsers = axios.CancelToken.source();

      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodySummaryForUsers.token;
      const { data } = await httpService.post(URL_USER_SUMARY_API, body);

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_SUMMARY_USERS,
        payload: response,
      });

      return TAB_SUMMARY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_SUMMARY_USERS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelAuditHistoryForUsers =
  (certkey, entValueKey, userKey) => async (dispatch) => {
    const body = {
      certkey,
      cert_entitlement_valuekey: entValueKey,
      cert_userkey: userKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyHistoryForUsers !== typeof undefined
      ) {
        cancelTokenForSidePanelBodyHistoryForUsers.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyHistoryForUsers = axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyHistoryForUsers.token;
      const { data } = await httpService.post(
        URL_AUDIT_HISTORY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_HISTORY2_USERS,
        payload:
          typeof response === 'object' && Array.isArray(response)
            ? response?.map((item, index) => ({
                ...item,
                index,
              }))
            : null,
      });

      if (typeof response === 'string')
        dispatch(setSidePanelErrorTryBlock(response));

      return TAB_HISTORY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_HISTORY2_USERS,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelSummaryForRoles =
  (eid, certkey, roleKey) => async (dispatch) => {
    const body = {
      eid,
      certkey,
      cert_rolekey: roleKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodySummaryForRoles !== typeof undefined
      ) {
        cancelTokenForSidePanelBodySummaryForRoles.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodySummaryForRoles = axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodySummaryForRoles.token;
      const { data } = await httpService.post(
        URL_ROLE_SUMMARY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_SUMMARY_ROLES,
        payload: response,
      });

      return TAB_SUMMARY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_SUMMARY_ROLES,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelAuditHistoryForRoles =
  (certkey, entValueKey, userKey, roleKey) => async (dispatch) => {
    const body = {
      certkey,
      cert_entitlement_valuekey: entValueKey,
      cert_userkey: userKey,
      cert_rolekey: roleKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyHistoryForRoles !== typeof undefined
      ) {
        cancelTokenForSidePanelBodyHistoryForRoles.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyHistoryForRoles = axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyHistoryForRoles.token;
      const { data } = await httpService.post(
        URL_AUDIT_HISTORY_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      dispatch({
        type: SET_SIDE_PANEL_HISTORY2_ROLES,
        payload:
          typeof response === 'object' && Array.isArray(response)
            ? response?.map((item, index) => ({
                ...item,
                index,
              }))
            : null,
      });

      if (typeof response === 'string')
        dispatch(setSidePanelErrorTryBlock(response));

      return TAB_HISTORY;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_HISTORY2_ROLES,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelEntitlementForRoles =
  (roleKey, offset, max, loadMoreStatus = SIDE_PANEL_INITIAL_LOAD) =>
  async (dispatch, getState) => {
    const {
      global: { certKey },
    } = getState().certifications.details;
    const body = {
      cert_rolekey: roleKey,
      offset: String(Number(offset) + 1),
      max,
      certkey: certKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyEntitlementForRoles !==
        typeof undefined
      ) {
        cancelTokenForSidePanelBodyEntitlementForRoles.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyEntitlementForRoles =
        axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyEntitlementForRoles.token;
      const { data } = await httpService.post(
        URL_ROLE_ENTITLEMENTS_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      if (loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        dispatch({
          type: SET_SIDE_PANEL_ENTITLEMENT_ROLES,
          loadMoreStatus,
          payload: {
            ...response,
            roleEntList: response?.roleEntList.map((item, index) => ({
              ...item,
              index: `${offset}-${index}`,
            })),
          },
        });
      }

      if (loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        dispatch({
          type: SET_SIDE_PANEL_ENTITLEMENT_ROLES,
          loadMoreStatus,
          payload: response?.roleEntList.map((item, index) => ({
            ...item,
            index: `${offset}-${index}`,
          })),
        });
      }

      return TAB_ENTITLEMENT;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_ENTITLEMENT_ROLES,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };

export const getSidePanelChildForRoles =
  (roleKey, offset, max, loadMoreStatus = SIDE_PANEL_INITIAL_LOAD) =>
  async (dispatch, getState) => {
    const {
      global: { certKey },
    } = getState().certifications.details;
    const body = {
      cert_rolekey: roleKey,
      offset: String(Number(offset) + 1),
      max,
      certkey: certKey,
    };

    dispatch(clearSidePanelError());

    try {
      if (
        typeof cancelTokenForSidePanelBodyChildForRoles !== typeof undefined
      ) {
        cancelTokenForSidePanelBodyChildForRoles.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelBodyChildForRoles = axios.CancelToken.source();
      const axiosRequestConfig = { ...axiosTimeoutConfig };

      axiosRequestConfig.cancelToken =
        cancelTokenForSidePanelBodyChildForRoles.token;
      const { data } = await httpService.post(
        URL_ROLE_CHILD_API,
        body,
        axiosRequestConfig
      );

      const { response } = data;

      if (loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        dispatch({
          type: SET_SIDE_PANEL_CHILDREN_ROLES,
          loadMoreStatus,
          payload: {
            ...response,
            childRoleList: response?.childRoleList.map((item, index) => ({
              ...item,
              index: `${offset}-${index}`,
            })),
          },
        });
      }

      if (loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        dispatch({
          type: SET_SIDE_PANEL_CHILDREN_ROLES,
          loadMoreStatus,
          payload: response?.childRoleList.map((item, index) => ({
            ...item,
            index: `${offset}-${index}`,
          })),
        });
      }

      return TAB_CHILDREN;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_SIDE_PANEL_CHILDREN_ROLES,
          payload: null,
        });
      }

      dispatch(setSidePanelErrorCatchBlock(error));

      throw Error(error);
    }
  };
